import { buildLink, LocationPage, RouteSlotInput } from '@luks/ui';

import { isDefined } from '../commons/is-defined';
import { Complete } from '../commons/types';
import { mapBreadcrumbs } from './Breadcrumbs';

export function mapLocationHeader(
  input: Complete<LocationHeaderFragment> & {
    breadcrumbs: Array<BreadcrumbItemFragment>;
  },
): RouteSlotInput<typeof LocationPage, 'header', 'LocationHeader'> {
  return {
    key: 'LocationHeader',
    input: {
      ...mapBreadcrumbs(input.breadcrumbs),
      title: input.location?.title || '',
      isPrimaryHeading: false,
      introText: input.location?.subtitle,
      buttonText: 'Kontakt und Anreise',
      AssignersLink: input.location?.contact?.path
        ? buildLink({ href: input.location.contact.path })
        : undefined,
      subNavigation:
        input.navigation?.filter(isDefined).map((item) => ({
          title: item.title,
          Link: buildLink({ href: item.url! }),
          active: item.isActive,
        })) || [],
      isInPageNav: false,
    },
  };
}
